import { ENV } from '@emobg/web-utils';

export const isLocalApi = process.env.NODE_ENV === ENV.local;

const apiHost = window.VUE_APP_API_URL || process.env.VUE_APP_API_URL;
export const host = isLocalApi ? '' : apiHost;
